import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-[#110038] py-24 md:py-32 relative overflow-hidden" data-id="element-151">
      {/* Purple Mesh Gradient Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-152">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[#7C3AED] opacity-20 blur-[120px]" data-id="element-153"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-[#4C1D95] opacity-30 blur-[150px]" data-id="element-154"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-155">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-12" data-id="element-156">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 text-center md:text-left order-1" data-id="element-157">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight font-serif" data-id="element-158">
              Cómo salvar tu relación y recuperar la Paz Mental, incluso si
              sentís que ya lo intentaste todo
            </h1>

            <p className="text-sm md:text-base text-[#C4B5FD] font-medium tracking-wide uppercase mb-6 font-sans" data-id="element-159">
              20 páginas. Sin relleno. Solo el protocolo exacto para los
              próximos 7 días.
            </p>

            <p className="text-lg md:text-xl text-[#A78BFA] mb-10 leading-relaxed font-sans" data-id="element-160">
              Descubre el método práctico para reconstruir la comunicación,
              sanar heridas y blindar tu pareja contra las crisis financieras y
              el agotamiento mental.
            </p>

            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(124, 58, 237, 0)', '0 0 0 15px rgba(124, 58, 237, 0.2)', '0 0 0 0 rgba(124, 58, 237, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="inline-block w-full md:w-auto bg-[#7C3AED] text-white px-8 py-5 rounded-lg text-lg font-semibold shadow-[0_10px_25px_-5px_rgba(124,58,237,0.5)] hover:bg-[#6D28D9] transition-colors mb-6 text-center font-sans tracking-wide" data-id="element-161">
              QUIERO SALVAR MI RELACION
            </motion.a>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 text-xs md:text-sm text-[#C4B5FD] font-sans" data-id="element-162">
              <div className="flex items-center gap-1.5" data-id="element-163">
                <DownloadIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-164" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-165">
                <ShieldCheckIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-166" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-167">
                <FileTextIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-168" />
                PDF
              </div>
            </div>
          </motion.div>

          {/* Right: Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 flex justify-center order-2 perspective-1000" data-id="element-169">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full max-w-[400px] flex justify-center" data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/1otX3pN3jAid8E1pjbZi1A/48g9UqSEtBv4jUvrnliaY.png" alt="Rescate de Pareja: Libro" className="w-full max-w-[320px] h-auto rounded-md transform -rotate-6" style={{
              boxShadow: '-20px 25px 50px rgba(0, 0, 0, 0.6), inset 2px 0 5px rgba(255,255,255,0.2)'
            }} data-id="element-171" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}